import React from 'react';
import services from '../../images/service.jpg';
import {AiOutlineReload, AiOutlineFileSearch} from 'react-icons/ai';
import {CgDesignmodo} from 'react-icons/cg';
import {GrSteps} from 'react-icons/gr';
import './css/choose.css'

const ChooseUS = () => {

    return (
        <div className='choose-us'>
            <div className='choose-us_info'>
                <h2>why choose us ?</h2>
                <p >hello world hello world...</p>
                <div className='home-services' data-aos="zoom-in-up" data-aos-duration="500">
                    <div className='home-services-items' >
                        <div className='home-services-logo'> <AiOutlineReload /></div>
                        <div>
                            <div>
                                <h3>planning</h3>
                            </div>
                            <div>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                            </div>
                        </div>
                    </div>

                    <div className='home-services-items' >
                        <div className='home-services-logo'><CgDesignmodo/></div>
                        <div>
                            <div>
                                <h3>design</h3>
                            </div>
                            <div>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                            </div>
                        </div>
                    </div>

                    <div className='home-services-items' >
                        <div className='home-services-logo'><AiOutlineFileSearch /></div>
                        <div>
                            <div>
                                <h3>research</h3>
                            </div>
                            <div>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                            </div>
                        </div>
                    </div>
                    
                    <div className='home-services-items' >
                        <div className='home-services-logo'><GrSteps /></div>
                        <div>
                            <div>
                                <h3>develope</h3>
                            </div>
                            <div>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='choose-us_img'> <img src={services} alt='Harsitha developers Trust us' data-aos="zoom-in-up" data-aos-duration="1000" height='100%' width='100%' /></div>
        </div>
    )
}

export default ChooseUS;
